<template>
  <div class="hello">
    <hero />
    <advantages />
    <about-cegjelzo />
    <my-footer />
  </div>
</template>

<script>
import Hero from './Hero'
import Advantages from './Advantages'
import AboutCegjelzo from './AboutCegjelzo'
import MyFooter from './Footer'

export default {
  name: 'HelloWorld',
  components: {
    Hero,
    Advantages,
    AboutCegjelzo,
    MyFooter
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
